import { Trans, useGetLocaleFromList } from "@l2r-front/l2r-i18n"
import { L2RLink } from "@l2r-front/l2r-ui"

import { cguLocales, getCguUrl } from "../../constants/cgu"
import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./LegalFooter.styled"

export function LegalFooter(props) {

    const { className } = props

    const currentLang = useGetLocaleFromList(cguLocales, cguLocales[0])

    return (
        <Styled.Container className={className}>
            <Trans
                namespace={I18N_NAMESPACE}
                i18nKey="components.legalFooter.label"
                components={{
                    CustomLink: (
                        <L2RLink
                            target="_blank"
                            rel="noreferrer"
                            to={getCguUrl(currentLang)}
                        />
                    ),
                }} />
        </Styled.Container>
    )
}